module.exports = __webpack_public_path__ + "static/media/FASANKAI_MENU-normal.304a27a2.png";